import { portalTabQueryKeys } from "@portal/Components/Portal/PotalTabs/types";
import { getPaymentDetails, getPaymentList, getPaymentMode } from "@portal/api/payment-list";
import { PaymentListFilters } from "@portal/store/Filters/credits/type";
import { tableAtom } from "@portal/store/table/table";
import { RequestConfig } from "@portal/types/common";
import { useQuery } from "@tanstack/react-query";
import produce from "immer";
import { useSetAtom } from "jotai";

function usePaymentListQuery(params: RequestConfig<PaymentListFilters>) {
  const setTableValue = useSetAtom(tableAtom);

  return useQuery({
    queryKey: [portalTabQueryKeys.PAYMENTS, params],
    queryFn: () => getPaymentList(params),
    retry: false,
    async onSuccess(data) {
      setTableValue((value) => {
        return produce(value, (draft) => {
          draft.bulk_records = data.total_records;
          return draft;
        });
      });
    },
    onError(err) {},
  });
}
function usePaymentDetailsQuery(params?: string) {
  return useQuery({
    queryKey: ["payment-details", params],
    queryFn: () => getPaymentDetails(params),
    retry: false,
    enabled: Boolean(params?.length),
  });
}

function useGetPaymentModeQuery() {
  return useQuery({
    queryKey: ["payment-mode"],
    queryFn: () => getPaymentMode(),
    retry: false,
  });
}

export { usePaymentDetailsQuery, usePaymentListQuery,useGetPaymentModeQuery };
